import React from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import 'tailwindcss/tailwind.css';

const PaymentsTable = ({ data }) => {
  // Ensure data is always an array
  const validatedData = React.useMemo(() => Array.isArray(data) ? data : [], [data]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Date registered',
        accessor: 'dateRegistered',
      },
      {
        Header: 'Client Name',
        accessor: 'clientName',
      },
      {
        Header: 'Mobile No',
        accessor: 'mobileNo',
      },
      {
        Header: 'Property',
        accessor: 'property',
      },
      {
        Header: 'Referrer CID',
        accessor: 'referrerCID',
      },
      {
        Header: 'Referrer Name',
        accessor: 'referrerName',
      },
      {
        Header: 'Total Cost',
        accessor: 'totalCost',
      },
      {
        Header: 'Amount paid',
        accessor: 'amountPaid',
      },
      {
        Header: 'Balance',
        accessor: 'balance',
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: validatedData,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useSortBy,
    usePagination
  );

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Recent payments</h1>
      <div className="bg-gray-100 p-2 rounded-lg shadow-md max-sm:w-[390px] ">
      <div className="overflow-x-auto max-sm:w-[370px]">
        <table {...getTableProps()} className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
            {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                    <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    {column.render('Header')}
                    <span>
                        {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                    </span>
                    </th>
                ))}
                </tr>
            ))}
            </thead>
            <tbody {...getTableBodyProps()} className="bg-white divide-y divide-gray-200">
            {page.length > 0 ? (
                page.map((row, i) => {
                prepareRow(row);
                return (
                    <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                        <td
                        {...cell.getCellProps()}
                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                        >
                        {cell.render('Cell')}
                        </td>
                    ))}
                    </tr>
                );
                })
            ) : (
                <tr>
                <td
                    colSpan={columns.length}
                    className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center"
                >
                    No data available in table
                </td>
                </tr>
            )}
            </tbody>
        </table>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center mt-4 space-y-4 md:space-y-0">
            <div>
            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                {'<<'}
            </button>{' '}
            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                {'<'}
            </button>{' '}
            <button onClick={() => nextPage()} disabled={!canNextPage}>
                {'>'}
            </button>{' '}
            <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                {'>>'}
            </button>{' '}
            </div>
            <span>
            Page{' '}
            <strong>
                {pageIndex + 1} of {pageOptions.length}
            </strong>{' '}
            </span>
            <span>
            | Go to page:{' '}
            <input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
                }}
                style={{ width: '100px' }}
            />
            </span>{' '}
            <select
            value={pageSize}
            onChange={(e) => {
                setPageSize(Number(e.target.value));
            }}
            >
            {[10, 20, 30, 40, 50].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                Show {pageSize}
                </option>
            ))}
            </select>
        </div>
      </div>
    </div>
  );
};

export default PaymentsTable;
